const getDefaultState = () => ({});

const state = () => getDefaultState();

export default {
  namespaced: true,

  state,

  actions: {
    setPartner({ commit }, partner) {
      commit('add', partner);
    }
  },

  mutations: {
    add(state, partner) {
      Object.keys(state).forEach(key => {
        delete state[key];
      });

      if (partner && typeof partner === 'object') {
        Object.assign(state, partner);
      }
    }
  }
};
